module.exports = __webpack_public_path__ + "static/media/G2.2859cd47.jpg";